import React from "react";
import Kpi from "./Kpi";

// Wrap your entire KPI container in React.memo
function KpiSection({ kpiData, mode, percentageRef }) {
  return (
    <div className="kpi-container">
      <Kpi header="Total Players (7 days)" number={kpiData.totalPlayers} percentage={kpiData.percentages.totalPlayers} mode={mode} percentageRef={percentageRef} />
      <Kpi header="Gameplays (7 days)" number={kpiData.gameplays} percentage={kpiData.percentages.gameplays} mode={mode} percentageRef={percentageRef} />
      <Kpi header="Avg Gameplay Minutes (7 days)" number={kpiData.avgTime / 60} percentage={kpiData.percentages.averageTime} mode={mode} percentageRef={percentageRef} />
      <Kpi header="Minutes Played (7 days)" number={kpiData.totalTime / 60} percentage={kpiData.percentages.totalTime} mode={mode} percentageRef={percentageRef} />
      <Kpi header="Ads (7 days)" number={kpiData.ads} percentage={kpiData.percentages.ads} mode={mode} percentageRef={percentageRef} />
    </div>
  );
}

// Only re-render if kpiData, mode, or percentageRef actually change
export default React.memo(KpiSection, (prevProps, nextProps) => {
  return prevProps.kpiData === nextProps.kpiData && prevProps.mode === nextProps.mode && prevProps.percentageRef === nextProps.percentageRef;
});
